import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import type { KeyboardEvent as ReactKeyboardEvent } from "react";
import type { CommonSelectProps } from "../CommonSelect";
import CommonTabsTab from "./CommonTabsTab";
export default function CommonTabs(props) {
  const $ = _c(41);
  const {
    items,
    activeItem,
    setSelected,
    filterLabel
  } = props;
  const sortDirection = "sortDirection" in props ? props.sortDirection : undefined;
  const disabled = "disabled" in props ? props.disabled ?? false : false;
  const size = "size" in props ? props.size : undefined;
  const scrollContainerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Map();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const tabRefs = useRef(t0);
  const [showStartFade, setShowStartFade] = useState(false);
  const [showEndFade, setShowEndFade] = useState(false);
  let t1;
  let t2;
  if ($[1] !== items) {
    t1 = () => {
      const keysToKeep = new Set(items.map(_temp));
      const staleKeys = [];
      tabRefs.current.forEach((_, key) => {
        if (!keysToKeep.has(key)) {
          staleKeys.push(key);
        }
      });
      staleKeys.forEach(key_0 => tabRefs.current.delete(key_0));
    };
    t2 = [items];
    $[1] = items;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const node = scrollContainerRef.current;
      if (!node) {
        setShowStartFade(false);
        setShowEndFade(false);
        return;
      }
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = node;
      setShowStartFade(scrollLeft > 0);
      setShowEndFade(scrollLeft + clientWidth < scrollWidth - 1);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const updateFadeIndicators = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      updateFadeIndicators();
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeItem || $[7] !== items) {
    t5 = [updateFadeIndicators, activeItem, items];
    $[6] = activeItem;
    $[7] = items;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const node_0 = scrollContainerRef.current;
      if (!node_0) {
        return;
      }
      updateFadeIndicators();
      node_0.addEventListener("scroll", updateFadeIndicators);
      if (globalThis.window !== undefined) {
        globalThis.window.addEventListener("resize", updateFadeIndicators);
      }
      return () => {
        if (node_0) {
          node_0.removeEventListener("scroll", updateFadeIndicators);
        }
        if (globalThis.window !== undefined) {
          globalThis.window.removeEventListener("resize", updateFadeIndicators);
        }
      };
    };
    t7 = [updateFadeIndicators];
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  if ($[11] !== items) {
    t8 = index => {
      const total = items.length;
      if (!total) {
        return;
      }
      const normalizedIndex = (index % total + total) % total;
      const targetItem = items[normalizedIndex];
      if (!targetItem) {
        return;
      }
      const tab = tabRefs.current.get(targetItem.key);
      tab?.focus();
    };
    $[11] = items;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const focusTab = t8;
  let t9;
  if ($[13] !== focusTab || $[14] !== items.length) {
    t9 = (event, currentIndex) => {
      bb57: switch (event.key) {
        case "ArrowRight":
        case "Right":
          {
            event.preventDefault();
            focusTab(currentIndex + 1);
            break bb57;
          }
        case "ArrowLeft":
        case "Left":
          {
            event.preventDefault();
            focusTab(currentIndex - 1);
            break bb57;
          }
        case "Home":
          {
            event.preventDefault();
            focusTab(0);
            break bb57;
          }
        case "End":
          {
            event.preventDefault();
            focusTab(items.length - 1);
            break bb57;
          }
        default:
      }
    };
    $[13] = focusTab;
    $[14] = items.length;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleKeyDown = t9;
  const t10 = filterLabel ?? "Filter options";
  const t11 = props.fill ?? true ? "tw-min-w-full" : "tw-w-fit";
  let t12;
  if ($[16] !== t11) {
    t12 = clsx("tw-flex tw-flex-nowrap tw-gap-x-1 tw-rounded-lg tw-bg-iron-950 tw-p-1 tw-ring-1 tw-ring-inset tw-ring-iron-700", t11);
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== activeItem || $[19] !== disabled || $[20] !== handleKeyDown || $[21] !== items || $[22] !== props.fill || $[23] !== setSelected || $[24] !== size || $[25] !== sortDirection) {
    t13 = items.map((item_0, i) => <CommonTabsTab key={item_0.key} item={item_0} itemIdx={i} totalItems={items.length} activeItem={activeItem} sortDirection={sortDirection} setSelected={setSelected} isMobile={false} onKeyDown={event_0 => handleKeyDown(event_0, i)} buttonRef={node_1 => {
      if (!node_1) {
        tabRefs.current.delete(item_0.key);
        return;
      }
      tabRefs.current.set(item_0.key, node_1);
    }} disabled={disabled} fill={props.fill ?? true} size={size} />);
    $[18] = activeItem;
    $[19] = disabled;
    $[20] = handleKeyDown;
    $[21] = items;
    $[22] = props.fill;
    $[23] = setSelected;
    $[24] = size;
    $[25] = sortDirection;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t14) {
    t15 = <div ref={scrollContainerRef} role="tablist" aria-label={t10} aria-orientation="horizontal" className="tw-overflow-x-auto tw-scroll-smooth tw-scrollbar-thin tw-scrollbar-track-transparent tw-scrollbar-thumb-iron-700/60 horizontal-menu-hide-scrollbar">{t14}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== showStartFade) {
    t16 = showStartFade && <div className="tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-6 tw-bg-gradient-to-r tw-from-iron-950 tw-to-transparent" />;
    $[33] = showStartFade;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== showEndFade) {
    t17 = showEndFade && <div className="tw-pointer-events-none tw-absolute tw-right-0 tw-top-0 tw-h-full tw-w-6 tw-bg-gradient-to-l tw-from-iron-950 tw-to-transparent" />;
    $[35] = showEndFade;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t15 || $[38] !== t16 || $[39] !== t17) {
    t18 = <div className="tw-relative tw-w-full">{t15}{t16}{t17}</div>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
}
function _temp(item) {
  return item.key;
}